module.exports = __webpack_public_path__ + "img/pg5_distinguish.d6de3903.png";